import { FunctionalComponent, h } from '@stencil/core';
import { Language } from '@cesare';

interface QwSelectProps {
  QwSelectName?: string;
  QwSelectLabel?: string;
  QwSelectDisabled?: boolean;
  QwSelectIsMandatory?: boolean;
  QwSelectHasError?: boolean;
  QwSelectOnChange?: (e) => any;
}

export const QwSelect: FunctionalComponent<QwSelectProps> = (
  props,
  children,
) => {
  const ID = (Math.random() * 1000000).toFixed(0);
  return (
    <label
      htmlFor={props.QwSelectName + '__' + ID}
      class={`
      ${props.QwSelectName ? 'qw-select__' + props.QwSelectName : ''}
      ${props.QwSelectIsMandatory ? 'qw-select--mandatory' : ''}
      ${props.QwSelectHasError ? 'qw-select--error' : ''}
    `}
    >
      {props.QwSelectLabel && (
        <div class="qw-select__label">{props.QwSelectLabel}</div>
      )}
      <select
        id={props.QwSelectName + '__' + ID}
        disabled={props.QwSelectDisabled}
        onChange={(e) => props.QwSelectOnChange && props.QwSelectOnChange(e)}
      >
        {children.map((c) => c)}
      </select>
      {props.QwSelectHasError && (
        <div class="qw-select--mandatory__label">
          <span>{Language.getTranslation('mandatoryFields')}</span>
        </div>
      )}
    </label>
  );
};
